<template>
<div>
  <div class="d-flex flex-column justify-content-center align-items-center w-100 pb-4 bg-white border-bottom" >
  <div class="container">
    <h1 class="mt-5">FAQ</h1>
    <div class="mt-3 d-flex w-100  position-relative flex-wrap">
      <div class="form-inline px-4 bg-white border flex-fill">
        <i class="far fa-search" aria-hidden="true"></i>
        <input placeholder="Skriv din fråga här"  v-model="searchQuery" type="search" class="form-control flex-fill bg-transparent form-control-lg border-0 ">
      </div>
      
        <div class="ms-4 btn-group" role="group" >
          <button
            type="button"
            @click="display = 'categories'"
            :class="display == 'categories' ? 'btn-primary' : 'btn-secondary'"
            class="btn font-weight-bold">
            Kategori
          </button>
          <button
            type="button"
            @click="display = 'contacts'"
            :class="display == 'contacts' ? 'btn-primary' : 'btn-secondary'"
            class="btn font-weight-bold">
            Personal
          </button>
        </div></div>
      <div
        v-if="searchQuery.length > 2"
        class="position-absolute w-75 rounded bg-white searchResults shadow p-1 mx-auto border"
        style="z-index: 9; margin-top: 30px;"
        id="searchAccordion">
        <div class="p-2 ms-2">Sökresultat</div>
        
        <SearchAccordion :questions="searchResults.slice(0, 10)" :site="site" :display="display"></SearchAccordion>

        <template v-if="searchQuery.length > 2 && searchResults.length == 0">
          <div class="p-3 d-flex flex-row align-items-center bg-white" style="font-size: 16px !important">
            <i class="mr-3 fa-2x far fa-exclamation-triangle"></i>
            <div>Hittade tyvärr inget som matchade det du sökte på.</div>
          </div>
        </template>
      </div>
    </div>
  </div>

  <div v-if="display == 'contacts'" class="w-100" style="min-height: 107px;">
    <div class="d-flex flex-wrap my-4 justify-content-center">
      <a
        v-for="letter in alphabet"
        :key="letter"
        style="cursor: pointer"
        :style="{
          'text-decoration': selectedLetter == letter ? 'underline' : 'none',
        }"
        @click="filterContacts(letter)"
        ><div class="p-2">{{ letter }}</div></a
      >

      <a class="px-2" style="cursor: pointer" @click="filteredContacts = contacts"><div class="p-2">Visa alla</div></a>
    </div>
    <div class="pb-3">
      <button
        class="rounded-pill bg-white m-1 btn  border border-1 p-2 px-3 font-weight-normal"
        style="font-size: 14px;"
       
        @click="selectedContact = 'missing'"
        :class="{ 'btn-primary': selectedContact == 'missing' }">
        Ansvarig saknas
      </button>
      <button
        class="rounded-pill bg-white m-1 btn  border border-1 p-2 px-3 font-weight-normal"
        style="font-size: 14px;"
        v-for="(c, i) in filteredContacts"
        :key="i"
        @click="selectedContact = c"
        :class="{ 'btn-primary': selectedContact == c }">
        {{ c.name }}
      </button>
    </div>
  </div>
  <div v-if="loading" class="text-center mt-5">
    <img
      src="https://cdn.gavleenergi.se/img/spinner.svg"
      width="100"/>
  </div> 
  <div class="faqWrapper d-flex">
    <div v-if="display == 'categories' && !loading" class="faqCatWrapper d-flex">
  
      <CategoryRow :categories="mainCategories" :selectCat="selectMain" :selected="selectedMain" />

      <template v-if="selectedMain.id != 0 && selectedMain.name !== selectedSubCat.name"></template>

      <CategoryRow v-if="selectedMain.id != 0 && selectedMain.name !== selectedSubCat.name" :categories="currentSubCats" :selectCat="selectSubCat" :selected="selectedSubCat" />
      
      
      <template v-if="selectedSubSubCat.id != 0"></template>
      <CategoryRow v-if="selectedMain.id != 0 && selectedMain.name !== selectedSubCat.name" :categories="currentSubSubCats" :selectCat="selectSubSubCat" :selected="selectedSubSubCat" />


    </div>
    <div class="faqContentWrapper p-4 p-xl-5 w-100">

    <h4 v-if="currentQuestions.length > 0 && display == 'categories'" class="">
      <template v-if="selectedMain.name !== selectedSubCat.name">{{selectedMain.name}}<i class="fa-light fa-angle-right mx-2"></i>{{selectedSubCat.name}} <button class="btn-sm btn btn-light ms-2" @click="copy(selectedSubCat.id)"  data-toggle="tooltip" data-placement="top" title="Klicka för att kopiera ID."><i class="far fa-copy" aria-hidden="true"></i> {{ selectedSubCat.id }}</button>
        <span v-if="selectedSubSubCat.id != 0"><i class="fa-light fa-angle-right mx-2"></i>{{selectedSubSubCat.name}}</span> 
      </template>
      <template v-else>{{selectedSubCat.name}}  <button class="btn-sm btn btn-light ms-2" @click="copy(selectedSubCat.id)"  data-toggle="tooltip" data-placement="top" title="Klicka för att kopiera ID."><i class="far fa-copy" aria-hidden="true"></i> {{ selectedSubCat.id }}</button></template></h4>
    <h4 v-if="selectedContact !== '' && display == 'contacts'" class="text-center fs-4 mt-4 my-4">
      {{ selectedContact.name }}
    </h4>
    <div class="mb-2" v-if="currentQuestions.length > 0">
      {{ currentQuestions.length + " " + (currentQuestions.length == 1 ? "fråga" : "frågor") }}
    </div>
    <FaqAccordion v-if="currentQuestions.length > 0" :questions="currentQuestions" :currentQ="currentQ" :site="site" />

    </div>
    </div>
  </div>
  <ComponentStyles>
    * { box-sizing:border-box; } a { text-de } .btn-primary { font-weight: 400; } #boxSearchInput{ border-radius: 5px; border: solid 1px lightgrey;
    padding: 5px; } #boxSearchInput:focus-visible { outline: none; } .accordion-header{ font-size: 1rem; } .iconBg { width: 36px; height: 36px;
    {{ theme.iconBg }}
    } .boxWrapper ::-webkit-scrollbar { width: 0; height: 4px; } .livechatBtn{ border-radius: 2em; font-weight: 600; } .slide-main-leave-active,
    .slide-main-enter-active { transition: all 0.1s ease-in; } .slide-main-leave-to, .slide-main-enter-from { transform: translateX(200px); opacity:
    0; } .slide-sub-enter-active { transition: all .3s ease-in; } .slide-sub-leave-to, .slide-sub-enter-from { transform: translateY(15px); opacity:
    0; } @media only screen and (max-width: 400px) { .boxWrapper { width: 98%; inset: 0 1%; top: auto; bottom:100px; } } #boxQuestionAccordion
    .accordion-item{ border-bottom: 1px solid #ddd; } #boxQuestionAccordion.accordion-header{ font-size: 1em; margin: 0; } #boxQuestionAccordion
    .accordion-button{ font-weight: 600; border: 0 !important; background: none; font-size: 1em !important; display: block; width: 100%; text-align:
    left; padding: 16px 0; } #boxQuestionAccordion .accordion-button:focus{ outline: none !important; } .faqCatCard { cursor: pointer; min-width: 280px
    !important; }
    .selectedCategory {
      background: #63696f ;
      color: white;
    }
  </ComponentStyles>
</template>

<script>
import CategoryRow from "./CategoryRow.vue";
import SearchAccordion from "./SearchAccordion.vue";
import FaqAccordion from "./FaqAccordion.vue";
import ComponentStyles from "../componentStyles.vue";

export default {
  name: "StartFaq",

  components: { CategoryRow, SearchAccordion, FaqAccordion, ComponentStyles },
  props: ["site"],

  data() {
    let mainCategories = [];
    let subCategories = [];
    let searchResults = [];
    let currentQuestions = [];
    let questions = [];
    let selectedMain = { id: 0 };
    let selectedSubCat = { id: 0 };
    let selectedSubSubCat = { id: 0 };
    let currentSubCats = [];
    let currentSubSubCats = [];
    let currentQ;
    let searchQuery = "";
    let chatStatus = "online";
    let showFaq = false;
    let toggleIcon = "fa-solid fa-question-circle fs-2";
    
    let queryString = window.location.search;

    let theme = {
      toggleBtn: "background: #47525D; color: #FFF2E3;",
      chatBtn: "background : #47525D; color: #FFFFFF;",
      bg: " background: #F6F6F6;",
      iconBg: "background : #FFF2E3; color: #47525D;",
      helpText: "background: #47525D; color: #FFFFFF;",
      darkText: "color: #47525D",
    };

    if (this.site == "gn") {
      theme = {
        toggleBtn: "background: #0C555B; color: #DA9C4F;",
        chatBtn: "background : #0C555B ; color: #fff;",
        bg: "background: #E6EFF1;",
        iconBg: "background: #0C555B; color: #DA9C4F;",
        helpText: "background: #E6EFF1; color: #0C555B;",
        darkText: "color: #0C555B",
      };
    }

    return {
      alphabet: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "Å",
        "Ä",
        "Ö",
      ],
      mainCategories,
      subCategories,
      questions,
      selectedMain,
      selectedSubCat,
      selectedSubSubCat,
      currentSubCats,
      currentSubSubCats,
      currentQuestions,
      currentQ,
      chatStatus,
      chat: false,
      searchQuery,
      searchResults,
      showFaq,
      toggleIcon,
      subScrollValue: 0,
      maxScrollLeft: 1,
      theme,
      contacts: [],
      filteredContacts: [],
      selectedContact: "",
      display: "categories",
      selectedLetter: "",
      loading: true,
      
      queryString,
      
    };
  },

  methods: {
    fetchData() {
      //let url1 = "https://cockpit.gavleenergi.se/wp-json/wp/v2/categories?per_page=100&filter[meta_key]=site&filter[meta_value]="+this.site+"&filter[meta_compare]=LIKE";
      //let url2 = "https://cockpit.gavleenergi.se/wp-json/wp/v2/faq?per_page=100&filter[meta_key]=site&filter[meta_value]="+ this.site +"&filter[meta_compare]=LIKE";

      let url1 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?site=" + this.site + "&type=cat";
      let url2 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?site=" + this.site + "&type=que";

      Promise.all([fetch(url1).then((res) => res.json()), fetch(url2).then((res) => res.json())]).then((json) => {
        json[0].map((cat) => {
          if (cat.parent == 0) {
            this.mainCategories.push(cat);
          } else {
            this.subCategories.push(cat);
          }
        });
        this.questions = json[1];


        this.questions.map((q) => {
          if (q.acf.contacts) {
            Object.values(q.acf.contacts).map((contact) => {
              if (this.contacts.findIndex((element) => element.name == contact.user_firstname + ' ' + contact.user_lastname) == -1) {
                this.contacts.push({
                  id: contact.user_nicename,
                  name: contact.user_firstname + ' ' + contact.user_lastname,
                });
              }
            });
          }
        });

        const urlParams = new URLSearchParams(this.queryString);
        //console.log(urlParams.get("q"))
        if (urlParams.get("q")) {
          let urlQ = urlParams.get("q");
          let q = this.questions.find(({ id }) => id == urlQ);
          this.setCurrentQ(q);
        //console.log(urlQ)
        } else if (urlParams.get("c")){
          let urlC = urlParams.get("c");
          let c = this.subCategories.find(({ id }) => id == urlC);
          //console.log(c)
          let mc = this.mainCategories.find(({ id })=> id == c.parent);
          //console.log(mc)
          this.selectMain(mc)
          this.selectSubCat(c)
        } else {
          this.selectMain(this.mainCategories[0])
        }




        this.contacts.sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        });
      });

      this.filteredContacts = this.contacts;
      this.loading = false;
    },

    selectMain(cat) {
      this.currentSubCats = [];
        this.selectSubCat(this.subCategories.find(({ parent }) => parent == cat.id));
        //this.selectSubCat(this.subCategories[4])
    
      this.subCategories.map((subCat) => {
        if (subCat.parent == cat.id) {
          this.currentSubCats.push(subCat);
        }
      });



      this.subScrollValue = 0;
      this.selectedMain = cat;
    },

    selectSubCat(cat) {
      this.currentQuestions = [];
      this.currentSubSubCats = [];
      this.selectedSubSubCat = {id: 0};
      this.selectedSubCat = cat;

      if (this.subCategories.find(({ parent }) => parent == cat.id)) {
        this.selectSubSubCat(this.subCategories.find(({ parent }) => parent == cat.id));
        //this.selectSubCat(this.subCategories[4])
        this.subCategories.map((subCat) => {
        if (subCat.parent == cat.id) {
            this.currentSubSubCats.push(subCat);
          }
        });
      } else {
        this.questions.map((q) => {
        if (q.categories.find((id) => id == cat.id)) {
          this.currentQuestions.push(q);
        }
      });
      }


      
    },

    selectSubSubCat(cat) {
      this.currentQuestions = [];
      this.selectedSubSubCat = cat;
     

      this.questions.map((q) => {
        if (q.categories.find((id) => id == cat.id)) {
          this.currentQuestions.push(q);
        }
      });
    },

    setCurrentQ(q) {
      this.currentQ = q;
      this.currentQuestions = [];

      let category = this.subCategories.find(({ id }) => id == q.categories[0]);

      if(this.mainCategories.find(({ id }) => id == category.parent)){
        this.selectMain( this.mainCategories.find(({ id }) => id == category.parent));
        this.selectSubCat(category)
        
      } else { 
          let subsub = category;
          let sub = this.subCategories.find(({ id }) => id == subsub.parent);
          let main = this.mainCategories.find(({ id }) => id == sub.parent);

          this.selectMain(main)
          this.selectSubCat(sub);
          this.selectSubSubCat(subsub);
         
      }


      this.questions.map((q) => {
        if (q.categories[0] == category.id) {
          this.currentQuestions.push(q);
        }
      });



      window.setTimeout(() => {
          document.getElementById(q.id).scrollIntoView({ behavior: "smooth" });
        }, 200);
    },


    reset() {
      this.selectedMain = { id: 0 };
      this.selectedSubCat = { id: 0 };
      this.currentQuestions = [];
      this.currentQ = "";
    },

    checkChatState(status) {
      if (status == "online") {
        this.chatOnline = true;
      } else {
        this.chatOnline = false;
      }
      this.iconControl();
    },

    iconControl() {
      if (this.showFaq == false && this.chatOnline == false) {
        this.toggleIcon = "fa-solid fa-question-circle fs-2";
      } else if (this.showFaq == false && this.chatOnline == true) {
        this.toggleIcon = " fa-solid fa-message-lines fs-3";
      } else {
        this.toggleIcon = "fa-light fa-xmark fs-3";
      }
    },

    subCatScroll(direction) {
      let subCatContainer = document.querySelector("#boxSubCatContainer");

      this.maxScrollLeft = subCatContainer.scrollWidth - subCatContainer.clientWidth - 1;

      direction == "right" ? (subCatContainer.scrollLeft += 150) : (subCatContainer.scrollLeft -= 150);
      window.setTimeout(() => {
        this.subScrollValue = subCatContainer.scrollLeft;
      }, 200);
      window.setTimeout(() => {
        //console.log(subCatContainer.scrollLeft + "max: " + this.maxScrollLeft);
      }, 200);
    },

    
    searchFilter(row) {
    let searchWordArray = this.searchQuery.split(" ");

    return searchWordArray.some(word => this.filterWords(row, word));
  },

  filterWords(row, word) {
    if (row.title?.rendered?.toLowerCase().includes(word.toLowerCase())) {
      return true;
    }

    if (Object.values(row).some(prop => prop?.toString().toLowerCase().includes(word.toLowerCase()))) {
      return true;
    }

    if (row.acf?.contacts && Object.values(row.acf.contacts).some(p => {
      return (
        p.user_firstname.toLowerCase().includes(word.toLowerCase()) ||
        p.user_lastname.toLowerCase().includes(word.toLowerCase()) ||
        p.user_nicename.toLowerCase().includes(word.toLowerCase())
      );
    })) {
      return true;
    }

    return false;
  },
    filterContacts(letter) {
      this.selectedLetter = letter;

      this.filteredContacts = this.contacts.filter((c) => {
        return c.name.toUpperCase().startsWith(letter);
      });
    },
    copy(text) {
      navigator.clipboard.writeText(text);
    },
  },

  watch: {
    display() {
      //console.log(this.display);
    },

    selectedContact() {
      console.log("selectedcontactwatchern")
      //console.log(this.selectedContact)
      this.currentQuestions = this.questions.filter((q) => {
        let temp = false;
        if (q.acf.contacts) {
         
          Object.values(q.acf.contacts).map((c) => {
            if (c.user_firstname + ' ' + c.user_lastname == this.selectedContact.name) {
              temp = true;
              //console.log(this.selectedContact);
            }
          });
        } else if (!q.acf.contacts && this.selectedContact == 'missing'){temp = true;}
        return temp;
      });
    },

    searchQuery() {
    console.log(this.searchQuery);
    if (this.searchQuery.length > 0) {
      this.searchResults = this.questions.filter(this.searchFilter);
      
    } else {
      this.searchResults = [];
    }
  }

    
  },

  mounted() {
    this.fetchData();
  },
};
</script>
